import { Pipe, PipeTransform } from '@angular/core';
import { MinimalPatientAttachment } from 'app/core/models/minimal-patient-attachment.model';

@Pipe({ name: 'patientAttachmentDisplayName' })
export class PatientAttachmentDisplayNamePipe implements PipeTransform {
  transform(patientAttachment: MinimalPatientAttachment): string {
    if (patientAttachment.ehrConsultNoteReference) {
      return `${patientAttachment.ehrConsultNoteReference.name} (EHR Reference)`;
    } else if (patientAttachment.fileName) {
      return patientAttachment.fileName;
    } else {
      return '(NO NAME)';
    }
  }
}
